import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import fetcher from "@/common/axiosInstance";
import ReservedPostException from "@/exceptions/postExceptions/ReservedPostException";
import { ValidationException } from "@/common/exceptions/ValidationException";
import InternalServerError500Exception from "@/exceptions/InternalServerError500Exception";
import UnprocessableEntityError from "@/exceptions/UnprocessableEntityError";
export var OrderPaidError = /*#__PURE__*/function (_UnprocessableEntityE) {
  function OrderPaidError() {
    var _this;
    _classCallCheck(this, OrderPaidError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OrderPaidError, [].concat(args));
    _defineProperty(_this, "name", "OrderPaidError");
    return _this;
  }
  _inherits(OrderPaidError, _UnprocessableEntityE);
  return _createClass(OrderPaidError);
}(UnprocessableEntityError);
export var PostReservedError = /*#__PURE__*/function (_UnprocessableEntityE2) {
  function PostReservedError() {
    var _this2;
    _classCallCheck(this, PostReservedError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, PostReservedError, [].concat(args));
    _defineProperty(_this2, "name", "PostReservedError");
    return _this2;
  }
  _inherits(PostReservedError, _UnprocessableEntityE2);
  return _createClass(PostReservedError);
}(UnprocessableEntityError);
export function api__getOrderWithPaymentInfo(_x, _x2, _x3, _x4) {
  return _api__getOrderWithPaymentInfo.apply(this, arguments);
}
function _api__getOrderWithPaymentInfo() {
  _api__getOrderWithPaymentInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(user_id, orderId, post_id, additionalIncludes) {
    var _res$data1, _res$data10, _res$data10$data, _res$data11, _res$data12, _data$customer, _data$customer2;
    var defaultIncludes, includes, params, queryParams, res, data;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          defaultIncludes = ['roadService', 'warranty', 'banks', 'faqs', 'financeSteps', 'warrantyV2'];
          if (orderId) {
            defaultIncludes.push('payment_info');
          }
          // Merge default includes with additional includes (like 'tamara')
          includes = additionalIncludes ? [].concat(defaultIncludes, _toConsumableArray(additionalIncludes)) : defaultIncludes;
          if (!(!orderId && !post_id)) {
            _context6.n = 1;
            break;
          }
          throw new Error("orderId or post_id is required");
        case 1:
          params = new URLSearchParams();
          params.append('include', includes.join(','));
          if (orderId) params.append('orderid', orderId.toString());
          if (post_id) params.append('post_id', post_id.toString());
          params.append('is_online', '1');
          queryParams = params.toString();
          _context6.n = 2;
          return fetcher().get("/order/get-details?".concat(queryParams));
        case 2:
          res = _context6.v;
          if (!(!(res !== null && res !== void 0 && (_res$data1 = res.data) !== null && _res$data1 !== void 0 && _res$data1.success) || !(res !== null && res !== void 0 && (_res$data10 = res.data) !== null && _res$data10 !== void 0 && (_res$data10$data = _res$data10.data) !== null && _res$data10$data !== void 0 && _res$data10$data.post_id) || Array.isArray(res === null || res === void 0 ? void 0 : (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.data))) {
            _context6.n = 3;
            break;
          }
          throw new Error("Failed to get order details, orderId: ".concat(orderId, ", post_id: ").concat(post_id));
        case 3:
          data = (res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.data) || {};
          if (!(data.post_url && data !== null && data !== void 0 && (_data$customer = data.customer) !== null && _data$customer !== void 0 && _data$customer.id && user_id && Number(data === null || data === void 0 ? void 0 : (_data$customer2 = data.customer) === null || _data$customer2 === void 0 ? void 0 : _data$customer2.id) != Number(user_id) && (data.reserved_status && data.reserved_status != 1 || post_id && data.post_id && data.post_id != post_id || data.is_deleted))) {
            _context6.n = 4;
            break;
          }
          throw new ReservedPostException(data.post_id);
        case 4:
          data.city_id = Number(data.city_id);
          return _context6.a(2, data);
      }
    }, _callee6);
  }));
  return _api__getOrderWithPaymentInfo.apply(this, arguments);
}
export var api__createOrder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(formData) {
    var _res$data, _res$data2, _res$data3;
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().post("/order/create", formData);
        case 1:
          res = _context.v;
          if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, res.data.data);
        case 2:
          if (!((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === 230 || (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.code) === 422)) {
            _context.n = 3;
            break;
          }
          throw ValidationException.factoryFromAxios(res);
        case 3:
          throw InternalServerError500Exception.factoryFromAxios(res);
        case 4:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function api__createOrder(_x5) {
    return _ref.apply(this, arguments);
  };
}();
export var api__createOrderOutSideWorkingOur = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(post_id, formData) {
    var updatedFormData, _res$data4, res, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          // Create a new object to avoid mutating the original formData
          updatedFormData = _objectSpread(_objectSpread({}, formData), {}, {
            is_online: 1,
            reserve_car_by_phone: 1,
            post_id: post_id
          });
          _context2.p = 1;
          _context2.n = 2;
          return fetcher().post("/order/create", updatedFormData);
        case 2:
          res = _context2.v;
          if (!(res !== null && res !== void 0 && (_res$data4 = res.data) !== null && _res$data4 !== void 0 && _res$data4.success)) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, res.data.data);
        case 3:
          throw new InternalServerError500Exception("Failed to create offline order 'api__createOrderOutSideWorkingOur' ");
        case 4:
          _context2.p = 4;
          _t = _context2.v;
          throw ValidationException.factoryFromAxios(_t);
        case 5:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 4]]);
  }));
  return function api__createOrderOutSideWorkingOur(_x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__getOrderDetailsByParams = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(formData, additionalIncludes) {
    var _res$data5, _res$data6, _res$data6$data, _res$data7, _res$data8;
    var defaultIncludes, includes, EXCLUDED_KEYS, queryParams, res, data;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          defaultIncludes = ['roadService', 'warranty', 'banks', 'faqs', 'financeSteps', 'warrantyV2'];
          includes = additionalIncludes ? [].concat(defaultIncludes, _toConsumableArray(additionalIncludes)) : defaultIncludes; // Fields that belong to order creation only — must NOT be sent to get-details
          EXCLUDED_KEYS = new Set(['full_name', 'phone_number', 'whatsapp_optin']);
          queryParams = new URLSearchParams(_objectSpread(_objectSpread({}, Object.fromEntries(Object.entries(formData).filter(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];
            return value != null && !EXCLUDED_KEYS.has(key);
          }).map(function (_ref6) {
            var _ref7 = _slicedToArray(_ref6, 2),
              key = _ref7[0],
              value = _ref7[1];
            return [
            // rename v_warranty_id → warranty_id
            key === 'v_warranty_id' ? 'warranty_id' : key, String(value)];
          }))), {}, {
            is_online: '1',
            include: includes.join(',')
          })).toString();
          _context3.n = 1;
          return fetcher().get("/order/get-details?".concat(queryParams));
        case 1:
          res = _context3.v;
          if (!(!(res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.success) || !(res !== null && res !== void 0 && (_res$data6 = res.data) !== null && _res$data6 !== void 0 && (_res$data6$data = _res$data6.data) !== null && _res$data6$data !== void 0 && _res$data6$data.post_id) || Array.isArray(res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.data))) {
            _context3.n = 2;
            break;
          }
          throw new Error("Failed to get order details");
        case 2:
          data = (res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.data) || {};
          data.city_id = Number(data.city_id);
          return _context3.a(2, data);
      }
    }, _callee3);
  }));
  return function api__getOrderDetailsByParams(_x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__getWarrantyList = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(params) {
    var _res$data9;
    var queryParams, res;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          queryParams = new URLSearchParams();
          if (params.post_id) queryParams.append('post_id', params.post_id.toString());
          if (params.warranty_id) queryParams.append('warranty_id', params.warranty_id.toString());
          if (params.installment_period) queryParams.append('installment_period', params.installment_period.toString());
          _context4.n = 1;
          return fetcher().get("/finance/get-warranty-list?".concat(queryParams.toString()));
        case 1:
          res = _context4.v;
          if (res !== null && res !== void 0 && (_res$data9 = res.data) !== null && _res$data9 !== void 0 && _res$data9.success) {
            _context4.n = 2;
            break;
          }
          throw new Error("Failed to get warranty list");
        case 2:
          return _context4.a(2, res.data.data);
      }
    }, _callee4);
  }));
  return function api__getWarrantyList(_x0) {
    return _ref8.apply(this, arguments);
  };
}();
export var api__getPromoCode = /*#__PURE__*/function () {
  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref9) {
    var _res$data0;
    var code, post_id, city_id, res;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          code = _ref9.code, post_id = _ref9.post_id, city_id = _ref9.city_id;
          _context5.n = 1;
          return fetcher().post("/order/referral-code-check", {
            code: code,
            post_id: post_id,
            city_id: city_id
          });
        case 1:
          res = _context5.v;
          if (res !== null && res !== void 0 && (_res$data0 = res.data) !== null && _res$data0 !== void 0 && _res$data0.success) {
            _context5.n = 2;
            break;
          }
          throw new Error("Failed to get promo code");
        case 2:
          return _context5.a(2, res.data.data);
      }
    }, _callee5);
  }));
  return function api__getPromoCode(_x1) {
    return _ref0.apply(this, arguments);
  };
}();